import styles from './Footer.module.css';
import gemsLogo from '../../assets/gemsLogo.png';
import honorsLogo from '../../assets/honorsLogo.png';
const Footer = (): JSX.Element => {
  return (
    <div className={styles.container}>
      <a href="https://www.gemstone.umd.edu" target="_blank">
        <img className={styles.gemsLogo} src={gemsLogo}></img>
      </a>
      <a href="http://www.honors.umd.edu" target="_blank">
        <img className={styles.honorsLogo} src={honorsLogo}></img>
      </a>
    </div>
  );
};

export default Footer;
